import { PageMetaData } from '../../components/providers/pageMetaData/pageMetaData';
import { Fullscreen } from './components/Fullscreen';
import { World } from './components/World';
import { About } from './components/About';
import styles from './Home.module.scss';

export const Home = ({ pages, uiBlocks }) => {
  const upPage = !!pages ? pages.find((el) => el.id === 33) : false;
  const upContact = !!uiBlocks ? uiBlocks.find((el) => el.id === 104) : false;
  const seo = !!upPage ? upPage.acf.seo : false;

  return (
    <>
      {!!seo && <PageMetaData seo={seo} />}
      <main className="main">
        {!!upPage ? <Fullscreen upPage={upPage} /> : ''}
        {!!upPage ? <World upPage={upPage} /> : ''}
        {!!upPage && !!upContact ? <About upPage={upPage} upContact={upContact} /> : ''}
      </main>
    </>
  );
};
